import React from 'react';
import { Box, Typography } from '@mui/material';
import { ReactComponent as GrooveGateLogo } from '../../assets/logo/groovegate_logo.svg';

const Logo = ({ 
  width = 60, 
  height = 'auto', 
  color = '#a187f2',
  showText = true,
  textColor = '#a187f2',
  fontSize = '1.5rem',
  onClick,
  sx = {} 
}) => {
  return (
    <Box 
      component="span"
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        cursor: onClick ? 'pointer' : 'default',
        gap: 1.5,
        ...sx
      }}
    >
      <GrooveGateLogo
        style={{
          width: width,
          height: height,
          fill: color,
          display: 'block'
        }}
      />
      {showText && (
        <Typography
          variant="h6"
          component="span"
          sx={{
            color: textColor,
            fontSize: fontSize,
            fontWeight: 600,
            letterSpacing: '0.5px',
            fontFamily: '"Martian Mono", "Martian Mono Condensed", monospace, sans-serif'
          }}
        >
          GrooveGate
        </Typography>
      )}
    </Box>
  );
};

export default Logo;
